import { HOPIN_NPS_QUESTION_KEY } from './edit-survey';

export const isHopinNpsQuestion = question =>
  question.question_i18n_key === HOPIN_NPS_QUESTION_KEY;
